<template>
    <div class="column">
        <div style="padding-top: 20px; width: 100%;">
            <table class="table is-responsive is-fullwidth">
                <thead>
                <tr>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Method</th>
                    <th>Amount</th>
                    <th>Transaction</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="transaction in getTransactions">
                        <td>{{ transaction.created_at }}</td>
                        <td>{{ types[transaction.type] }}</td>
                        <td>{{ methods[transaction.method] }}</td>
                        <td>{{ transaction.amount }}</td>
                        <td>{{ transaction.transaction_id }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                types: [
                    'Deposit',
                    'Deduct'
                ],
                methods: [
                    'Deposit by Admin',
                    'PayPal',
                    'Credit Card',
                    'Bank transfer'
                ]
            }
        },
        computed: {
            getTransactions: function () {
                return this.$store.getters.getTransactions
            }
        }
    }
</script>

<style scoped>
    @media screen and (max-width: 800px) {
        .is-responsive {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;
            display: block;
            position: relative;
        }
        .is-responsive td:empty:before {
            content: " ";
        }
        .is-responsive th,
        .is-responsive td {
            margin: 0;
            vertical-align: top;
        }
        .is-responsive th {
            text-align: left;
        }
        .is-responsive thead {
            border-right: solid 2px #dbdbdb;
            display: block;
            float: left;
        }
        .is-responsive thead tr {
            display: block;
            padding: 0 10px 0 0;
        }
        .is-responsive thead tr th::before {
            content: " ";
        }
        .is-responsive thead td,
        .is-responsive thead th {
            border-width: 0 0 1px;
        }
        .is-responsive tbody {
            display: block;
            width: auto;
            position: relative;
            overflow-x: auto;
            white-space: nowrap;
        }
        .is-responsive tbody tr {
            display: inline-block;
            vertical-align: top;
        }
        .is-responsive th {
            display: block;
            text-align: right;
            height: 45px !important;
            min-height: 45px !important;
        }
        .is-responsive td {
            display: block;
            height: 45px !important;
            min-height: 45px !important;
            text-align: left;
            font-size: 12px !important;
        }
        .is-responsive th:last-child,
        .is-responsive td:last-child {
            border-bottom-width: 0;
        }
        .is-responsive tr:last-child td:not(:last-child) {
            border: 1px solid #dbdbdb;
            border-width: 0 0 1px;
        }
        .is-responsive.is-bordered td,
        .is-responsive.is-bordered th {
            border-width: 1px;
        }
        .is-responsive.is-bordered tr td:last-child,
        .is-responsive.is-bordered tr th:last-child {
            border-bottom-width: 1px;
        }
        .is-responsive.is-bordered tr:last-child td,
        .is-responsive.is-bordered tr:last-child th {
            border-width: 1px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/User/UserTransactions.vue